/** Bloc Puck imbriqué (`{ type, props }`). */
export type PuckBlockNode = {
  type: string;
  props: Record<string, unknown>;
};

/**
 * Conteneur par défaut de la colonne texte d'un bloc Texte + Image.
 * Donne accès aux réglages Conteneur (direction, marges, hauteur, fond…)
 * tout en gardant le slot parent ouvert aux autres blocs de mise en page.
 */
export function createTextImageContainerWrapper(
  parentId: string,
  innerContent: PuckBlockNode[] = [],
): PuckBlockNode {
  return {
    type: "Container",
    props: {
      id: `${parentId}-text-container`,
      direction: "column",
      align: "stretch",
      justify: "start",
      gap: "none",
      paddingX: "none",
      paddingY: "none",
      maxWidth: "full",
      background: "none",
      height: { value: null, unit: "px" },
      content: innerContent,
    },
  };
}
